import { ArcElement, Chart as ChartJS, DoughnutController } from "chart.js";

ChartJS.register(ArcElement, DoughnutController);
